export const urls = {
  home: '',
  _: '.',
  back: '-1',

  signIn: 'sign-in',
  // main
  documentsList: 'documents',
  taxLegislation: '',
  // todo возможно не нужны
  // taxForms: 'tax-forms',

  document: (id: string | number = ':id') => `documents/${id}`,

  // admin management
  documentCreation: 'documents/create',
  documentEdit: (id: string | number = ':id') => `documents/${id}/edit`,

  // super admin management
  users: 'users',
  logs: 'logs',
  dashboard: 'dashboard',
  aiSalyk: 'ai-salyk',

  // tax legislation sub-pages
  taxLegislationRegistration: 'tax-legislation/registration-liquidation',
  taxLegislationReporting: 'tax-legislation/tax-reporting',
  taxLegislationEaeu: 'tax-legislation/eaeu-legislation',
  taxLegislationMarking: 'tax-legislation/product-marking',
  taxLegislationAudits: 'tax-legislation/tax-audits',
  taxLegislationInvoice: 'tax-legislation/electronic-invoice',
  taxLegislationRegimes: 'tax-legislation/special-tax-regimes',
  taxLegislationInsurance: 'tax-legislation/insurance-contributions',
  taxLegislationDebt: 'tax-legislation/debt-collection',
  taxLegislationProperty: 'tax-legislation/property-tax',
  taxLegislationNonTax: 'tax-legislation/non-tax-income',
  taxLegislationRefund: 'tax-legislation/tax-offset-refund',
};
